// RealBoyInWindow.js
import React from "react";

const RealBoyInWindow = ({
  phase = "idle",
  passwordState = "idle",
  cartoonActivity = "idle",
}) => {
  // ...existing code from RealBoyInWindow in oAuth/index.js...
  // (Copy the full RealBoyInWindow function body here, minus the export default)

  // Facial expressions
  let mouth, browL, browR, eyes;
  if (phase === "typing-password" && passwordState === "smile") {
    mouth = (
      <path
        d="M113 130 Q120 137 127 130"
        stroke="#e06d16"
        strokeWidth="2"
        fill="none"
      />
    );
    browL = (
      <path
        d="M110,118 Q115,116 120,120"
        stroke="#a87330"
        strokeWidth="2"
        strokeLinecap="round"
      />
    );
    browR = (
      <path
        d="M122,120 Q127,116 132,118"
        stroke="#a87330"
        strokeWidth="2"
        strokeLinecap="round"
      />
    );
  } else if (phase === "typing-password" && passwordState === "angry") {
    mouth = (
      <path
        d="M113 134 Q120 127 127 134"
        stroke="#c72c41"
        strokeWidth="2"
        fill="none"
      />
    );
    browL = (
      <path
        d="M111,116 Q118,110 120,119"
        stroke="#96442a"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    );
    browR = (
      <path
        d="M120,119 Q130,110 129,116"
        stroke="#96442a"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    );
  } else if (cartoonActivity === "bore") {
    mouth = (
      <ellipse
        cx="120"
        cy="135"
        rx="7"
        ry="4"
        fill="#efc191"
        stroke="#ad8c63"
        strokeWidth="1.5"
      />
    );
    browL = (
      <path
        d="M111,118 Q117,120 119,122"
        stroke="#ad8c63"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    );
    browR = (
      <path
        d="M121,122 Q124,120 129,118"
        stroke="#ad8c63"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    );
  } else {
    mouth = (
      <path
        d="M113 132 Q120 134 127 132"
        stroke="#9d4e15"
        strokeWidth="2"
        fill="none"
      />
    );
    browL = (
      <path
        d="M113,120 Q118,116 120,122"
        stroke="#7a4c27"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    );
    browR = (
      <path
        d="M120,122 Q125,116 130,120"
        stroke="#7a4c27"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    );
  }

  if (cartoonActivity === "hide-eyes") {
    eyes = null;
  } else if (cartoonActivity === "bore") {
    eyes = (
      <>
        <ellipse cx="116.5" cy="125" rx="4" ry="1.3" fill="#382f26" />
        <ellipse cx="124" cy="125" rx="4" ry="1.3" fill="#382f26" />
        <ellipse
          cx="116.5"
          cy="127"
          rx="4.2"
          ry="0.7"
          fill="#e7bc91"
          opacity="0.4"
        />
        <ellipse
          cx="124"
          cy="127"
          rx="4.2"
          ry="0.7"
          fill="#e7bc91"
          opacity="0.4"
        />
      </>
    );
  } else {
    eyes = (
      <>
        <ellipse cx="116.5" cy="125" rx="3.9" ry="3.5" fill="#473834" />
        <ellipse cx="124" cy="125" rx="3.9" ry="3.5" fill="#473834" />
        <ellipse cx="118" cy="124" rx="1" ry="1.1" fill="#fff" opacity="0.7" />
        <ellipse
          cx="122.8"
          cy="124"
          rx="1"
          ry="1.1"
          fill="#fff"
          opacity="0.7"
        />
      </>
    );
  }

  const skin = "#ffe2bb";
  const shadow = "#e5c8a0";

  function Arms() {
    if (cartoonActivity === "hide-eyes") {
      return (
        <>
          <rect
            x="93"
            y="145"
            width="14"
            height="39"
            rx="7"
            fill={skin}
            transform="rotate(-25 93 145)"
          />
          <rect
            x="103"
            y="106"
            width="10"
            height="36"
            rx="6"
            fill={skin}
            transform="rotate(22 103 106)"
          />
          <ellipse
            cx="109"
            cy="124"
            rx="8.5"
            ry="7"
            fill={skin}
            stroke={shadow}
            strokeWidth="0.7"
          />
          <rect
            x="130"
            y="145"
            width="14"
            height="39"
            rx="7"
            fill={skin}
            transform="rotate(25 130 145)"
          />
          <rect
            x="130"
            y="115"
            width="10"
            height="33"
            rx="6"
            fill={skin}
            transform="rotate(-18 130 115)"
          />
          <ellipse
            cx="131"
            cy="124"
            rx="8.5"
            ry="7"
            fill={skin}
            stroke={shadow}
            strokeWidth="0.7"
          />
        </>
      );
    }
    if (cartoonActivity === "wave") {
      return (
        <>
          <rect x="91" y="162" width="39" height="13" rx="6.5" fill={skin} />
          <ellipse cx="96" cy="168" rx="9" ry="6" fill={skin} />
          <rect
            x="122"
            y="146"
            width="13"
            height="34"
            rx="6"
            fill={skin}
            transform="rotate(-18 122 146)"
          />
          <rect
            x="126"
            y="93"
            width="10"
            height="49"
            rx="6"
            fill={skin}
            transform="rotate(20 126 93)"
          />
          <g className="realboy-hand realboy-wave">
            <ellipse
              cx="135"
              cy="91"
              rx="11"
              ry="7"
              fill={skin}
              stroke={shadow}
              strokeWidth="0.7"
            />
          </g>
        </>
      );
    }
    if (cartoonActivity === "typing-username") {
      return (
        <>
          <rect x="91" y="162" width="39" height="13" rx="6.5" fill={skin} />
          <ellipse cx="96" cy="168" rx="9" ry="6" fill={skin} />
          <rect
            x="130"
            y="148"
            width="11"
            height="33"
            rx="6"
            fill={skin}
            transform="rotate(-37 130 148)"
          />
          <rect
            x="133"
            y="115"
            width="9"
            height="33"
            rx="5"
            fill={skin}
            transform="rotate(-3 133 115)"
          />
          <g className="realboy-hand realboy-type">
            <ellipse
              cx="136"
              cy="113"
              rx="10"
              ry="6"
              fill={skin}
              stroke={shadow}
              strokeWidth="0.7"
            />
          </g>
        </>
      );
    }
    if (cartoonActivity === "bore") {
      return (
        <>
          <rect
            x="105"
            y="144"
            width="11"
            height="20"
            rx="5"
            fill={skin}
            transform="rotate(-31 105 144)"
          />
          <rect
            x="107"
            y="121"
            width="9"
            height="26"
            rx="5"
            fill={skin}
            transform="rotate(10 107 121)"
          />
          <ellipse
            cx="110"
            cy="136"
            rx="10"
            ry="7"
            fill={skin}
            stroke={shadow}
            strokeWidth="0.7"
          />
          <rect
            x="125"
            y="151"
            width="11"
            height="27"
            rx="6"
            fill={skin}
            transform="rotate(-7 125 151)"
          />
          <ellipse cx="136" cy="169" rx="10" ry="7" fill={skin} />
        </>
      );
    }
    return (
      <>
        <rect x="92.5" y="163" width="35" height="12" rx="6.5" fill={skin} />
        <ellipse cx="98" cy="169" rx="9" ry="6" fill={skin} />
        <rect x="122" y="163" width="35" height="12" rx="6.5" fill={skin} />
        <ellipse cx="138" cy="169" rx="9" ry="6" fill={skin} />
      </>
    );
  }

  let extraActivity = null;
  if (cartoonActivity === "bore") {
    extraActivity = (
      <text
        x="145"
        y="113"
        fontSize="15"
        fill="#b91c1c"
        opacity="0.5"
        style={{ fontFamily: "monospace", userSelect: "none" }}
      >
        Z
      </text>
    );
  } else if (cartoonActivity === "wave") {
    extraActivity = (
      <text
        x="135"
        y="100"
        fontSize="18"
        fill="#2563eb"
        style={{
          fontFamily: "sans-serif",
          fontWeight: 700,
          userSelect: "none",
        }}
      >
        Hey!
      </text>
    );
  }

  const windowHeight = 120,
    windowWidth = 104;
  const windowFrame = (
    <g>
      <rect
        x="68"
        y="85"
        width={windowWidth}
        height={windowHeight}
        rx="15"
        fill="#e0e7ff"
        stroke="#a3a3a3"
        strokeWidth="4"
      />
      <line
        x1="120"
        y1="85"
        x2="120"
        y2={85 + windowHeight}
        stroke="#cbd5e1"
        strokeWidth="2"
      />
      <line
        x1="68"
        y1={85 + windowHeight / 2}
        x2={172}
        y2={85 + windowHeight / 2}
        stroke="#cbd5e1"
        strokeWidth="2"
      />
    </g>
  );

  return (
    <svg
      width="210"
      height="215"
      viewBox="0 0 210 215"
      fill="none"
      style={{ display: "block" }}
    >
      {windowFrame}
      <rect x="109" y="145" width="22" height="36" rx="10" fill="#4593fc" />
      <rect
        x="113"
        y="180"
        width="13"
        height="7"
        rx="3.5"
        fill="#2a63b5"
        opacity="0.36"
      />
      <rect x="117" y="135" width="6" height="17" rx="2.9" fill={skin} />
      <ellipse
        cx="120"
        cy="127"
        rx="18"
        ry="19"
        fill={skin}
        stroke="#e3b679"
        strokeWidth="2"
      />
      <ellipse
        cx="106"
        cy="134"
        rx="3.7"
        ry="6.2"
        fill={skin}
        stroke="#e3b679"
        strokeWidth="1"
      />
      <ellipse
        cx="134"
        cy="134"
        rx="3.7"
        ry="6.2"
        fill={skin}
        stroke="#e3b679"
        strokeWidth="1"
      />
      <path
        d="M104 124 Q112 111 120 128 Q128 108 136 124 Q132 102 120 102 Q107 100 104 124 Z"
        fill="#704214"
      />
      {eyes}
      {browL}
      {browR}
      <ellipse cx="120" cy="133" rx="2.2" ry="5" fill="#e1ad80" opacity={0.6} />
      <ellipse
        cx="112"
        cy="138"
        rx="2.5"
        ry="1.8"
        fill="#f6bd79"
        opacity={passwordState === "smile" ? 0.33 : 0.18}
      />
      <ellipse
        cx="128"
        cy="138"
        rx="2.5"
        ry="1.8"
        fill="#f6bd79"
        opacity={passwordState === "smile" ? 0.33 : 0.18}
      />
      {mouth}
      <Arms />
      {extraActivity}
      <rect
        x="77"
        y="175"
        width="86"
        height="15"
        rx="7"
        fill="#beb9fd"
        stroke="#595959"
        strokeWidth="2"
      />
      <rect
        x="0"
        y="191"
        width="210"
        height="40"
        fill="#fff"
        style={{ opacity: 0 }}
      />
    </svg>
  );
};

export default RealBoyInWindow;
